import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TWhiteLabelPrimaryColors } from '../white-label.model';
import {
  DEFAULT_ORIGINAL_PRIMARY_COLORS,
  DEFAULT_PRIMARY_COLORS,
} from './white-label-defaults.const';

export function getDefaultPrimaryColors(): TWhiteLabelPrimaryColors {
  if (getFeatureFlag(EFeatureFlag.REBRAND)) {
    return DEFAULT_PRIMARY_COLORS;
  }

  return DEFAULT_ORIGINAL_PRIMARY_COLORS;
}
